import { atom, useAtom } from 'jotai'
import { Link } from '@tanstack/react-router'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { PRO_ADDS } from '@/lib/free-plan'
import { isFreeTier } from '@/lib/subscription-access'
import { ArrowRight } from 'lucide-react'

const upgradePromptAtom = atom<{ open: boolean; message: string }>({
  open: false,
  message: '',
})

// eslint-disable-next-line react-refresh/only-export-components
export function useUpgradePrompt() {
  const [state, setState] = useAtom(upgradePromptAtom)
  return {
    ...state,
    show: (message: string) => setState({ open: true, message }),
    close: () => setState({ open: false, message: '' }),
  }
}

export function UpgradePrompt() {
  const { open, message, close } = useUpgradePrompt()
  const { organization } = useAuth()

  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Plan limit reached</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        {isFreeTier(organization) && (
          <p className="text-sm text-body">
            You are on the free plan. Pro adds {PRO_ADDS}, from $3/mo.
          </p>
        )}
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={close}>
            Maybe later
          </Button>
          <Button asChild onClick={close}>
            <Link to="/pricing">
              View Plans
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
